import { useState, useEffect } from "react";
import { Receipt, TrendingUp, Coins, Wallet, Trophy } from "lucide-react";
import { Money, Credits } from "@/components/Currency";
import { api } from "@/lib/api";
import { toast } from "sonner";

const brl = (n) => `R$ ${Number(n || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;

const Card = ({ icon: Icon, label, value, testid, accent }) => (
  <div className="rounded-xl border border-border bg-card p-4" data-testid={testid}>
    <div className="flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-widest text-muted-foreground"><Icon className={`h-3.5 w-3.5 ${accent || "text-primary"}`} /> {label}</div>
    <div className="mt-1 font-num text-2xl font-bold">{value}</div>
  </div>
);

export default function ResellerSales() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/reseller/store/report").then(({ data }) => setR(data)).catch(() => toast.error("Erro ao carregar relatório")); }, []);

  if (!r) return <div className="text-muted-foreground">Carregando...</div>;

  return (
    <div className="space-y-6" data-testid="reseller-sales">
      <div className="flex items-center gap-2"><Receipt className="h-6 w-6 text-primary" /><h2 className="font-heading text-xl font-bold tracking-tight sm:text-2xl">Vendas da loja</h2></div>

      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Card icon={TrendingUp} label="Vendas" value={r.sales} testid="sales-count" />
        <Card icon={Wallet} label="Faturamento" value={<Money value={r.revenue} testid="sales-revenue-value" />} testid="sales-revenue" />
        <Card icon={Coins} label="Lucro (sobre base)" value={<Money value={r.profit} testid="sales-profit-value" />} testid="sales-profit" accent="text-green-500" />
        <Card icon={Coins} label="Créditos usados" value={<Credits value={r.credits_used} testid="sales-credits-used-badge" />} testid="sales-credits-used" />
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <Card icon={Coins} label="Meus créditos" value={<Credits value={r.credits} testid="sales-credits-badge" />} testid="sales-credits" />
      </div>
      <p className="text-xs text-muted-foreground">O dinheiro (R$) das vendas cai <b>direto no seu gateway</b> (Mercado Pago / Lynx). A VULPIX só debita os créditos da ativação da sua carteira.</p>

      <div className="rounded-xl border border-border bg-card">
        <div className="flex items-center gap-2 border-b border-border px-4 py-3 text-sm font-semibold"><Trophy className="h-4 w-4 text-primary" /> Mais vendidos</div>
        {r.top_apps.length === 0 ? (
          <div className="py-12 text-center text-sm text-muted-foreground">Nenhuma venda ainda. Divulgue o link da sua loja! 🚀</div>
        ) : (
          <div className="divide-y divide-border">
            {r.top_apps.map((a, i) => (
              <div key={a.name} className="flex items-center justify-between gap-3 px-4 py-3" data-testid={`top-app-${i}`}>
                <div className="flex min-w-0 items-center gap-3">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary/10 font-num text-xs font-bold text-primary">{i + 1}</span>
                  <span className="truncate font-medium">{a.name}</span>
                </div>
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-muted-foreground">{a.count} venda(s)</span>
                  <span className="font-num font-semibold">{brl(a.revenue)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
